import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=48b331b1&scoped=true&"
import script from "./myOrder.vue?vue&type=script&lang=js&"
export * from "./myOrder.vue?vue&type=script&lang=js&"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=48b331b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b331b1",
  null
  
)

export default component.exports